import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import InstallmentPaymentReceipt from '../../../../components/card/paymentReceipt/installmentPaymentReceipt';

function InstallmentPayment({ parentRoute = 'AssignedLoans', setState, referenceKey }: any) {
    const dispatch = useDispatch();

    useEffect(() => {

        // dispatch(setHeaderTitle({ color: 'var(--header-color)', header: 'رسید پرداخت', parentRoute: parentRoute }));
        // dispatch(changeRouteType({ routeType: 'child' }));
        // dispatch(getpervInnerState({ prevInnerState: parentRoute }));
    }, [])
    return (
        <div className='text-white mt-14'>
            <InstallmentPaymentReceipt setState={setState} />
        </div>
    )
}

export default InstallmentPayment